import styled from "styled-components";
import { mediaquery } from "@badi/badi-components";

export const ImageWrapper = styled.div`
  width: 100%;

  ${mediaquery.lg`
    width: 220px;
  `}
`;
